import React, { useContext } from 'react';
import { CioAutocompleteContext } from '../CioAutocompleteProvider';
import { isProduct, isInGroupSuggestion, isSearchSuggestion } from '../../../typeGuards';
import SectionItemText from './SectionItemText';
import { translate } from '../../../utils';
export default function SectionItem(props) {
    const { item, children, displaySearchTermHighlights } = props;
    const { getItemProps, advancedParameters, query, featureToggles } = useContext(CioAutocompleteContext);
    const { featureDisplaySearchSuggestionImages, featureDisplaySearchSuggestionResultCounts } = featureToggles;
    const { displaySearchSuggestionImages = featureDisplaySearchSuggestionImages, displaySearchSuggestionResultCounts = featureDisplaySearchSuggestionResultCounts, translations, } = advancedParameters || {};
    let defaultChildren;
    if (isProduct(item)) {
        defaultChildren = (React.createElement(React.Fragment, null,
            React.createElement("img", { "data-testid": 'cio-img', src: item.data?.image_url, alt: item.value, className: 'cio-product-image' }),
            React.createElement("p", { "data-testid": 'cio-text', className: 'cio-product-text' },
                React.createElement(SectionItemText, { item: item, query: query, highlightSearchTerm: displaySearchTermHighlights }))));
    }
    else if (isInGroupSuggestion(item)) {
        defaultChildren = (React.createElement("p", { className: 'cio-term-in-group' },
            translate('in', translations),
            ' ',
            React.createElement(SectionItemText, { item: item, query: query, highlightSearchTerm: displaySearchTermHighlights })));
    }
    else if (isSearchSuggestion(item)) {
        defaultChildren = (React.createElement(React.Fragment, null,
            displaySearchSuggestionImages && item.data?.image_url && (React.createElement("img", { src: item.data?.image_url, alt: item.value, className: 'cio-suggestion-image' })),
            React.createElement("p", { className: 'cio-suggestion-text' },
                React.createElement(SectionItemText, { item: item, query: query, highlightSearchTerm: displaySearchTermHighlights })),
            displaySearchSuggestionResultCounts && item.data?.total_num_results && (React.createElement("p", { className: 'cio-suggestion-count' },
                "(",
                item.data?.total_num_results,
                ")"))));
    }
    else {
        defaultChildren = (React.createElement("p", { className: 'cio-custom-text' },
            React.createElement(SectionItemText, { item: item, query: query, highlightSearchTerm: displaySearchTermHighlights })));
    }
    return React.createElement("li", { ...getItemProps(item) }, children || defaultChildren);
}
